import React from 'react';
import './Events.css';
 
// Import necessary components and constants
import { Event, Heading } from '../../../components';
import { eventContent, titles } from '../../../constants';
import { latestItems } from '../../../utils';

import { useTranslation } from 'react-i18next';

const Events = () => { 
  
  // Get the latest events (restricted to top 2 only)
  const topEvents = latestItems(eventContent).slice(0, 2);
  const t = useTranslation().t; 

  return (
    <section className='events'>
      
      {/* Section heading with title and subtitle */}
      <Heading title={t(titles.titleEvents)} subTitle={t(titles.subTitleEvents)} />

      <div className='box-container'>
        
        {/* Map through the top events and render each Event component */}
        {topEvents.map((event) => (
          <Event
            key={event.id} // Unique key for each event
            image={event.image} // Event image
            date={event.details.date} // Event date
            place={event.details.location} // Event location
            title={event.title} // Event title
          />
        ))}
      </div>

    </section>
  );
}

export default Events;